import { BaseSidebarObject } from '@y42/gojs';
import { IZOrderableNode } from '../../common/models/node.interfaces';

export class PinNode extends BaseSidebarObject implements IZOrderableNode {
  constructor(
    public key = '',
    public category = '',
    public location = '0 0',
    public layerName = '',
    public zOrder = NaN,
  ) {
    super();
  }
}
